import React from "react";
import style from "./style.module.css";
import Header from "../Header/Header.jsx";
import Lastreons from "../../../Assets/Lastreons.png";
import Offer from "./Offer.jsx";

export default function Coins ({ user }) {

    return (
        <div>
            <Header auth={true} user={user}/>
            <div className={style.rootDiv}>
                <div className={style.content}>
                    <div className={style.header}>
                        <button>Change currency to CZK</button>
                        <p>LASTREONS</p>
                        <div className={style.lastreons}>
                            <p>2560</p>
                            <img src={Lastreons} alt="Lastreons"/>
                        </div>
                    </div>
                    <div className={style.offers}>
                        <Offer price1={320} price2={0} price3={3}/>
                        <Offer price1={640} price2={60} price3={6}/>
                        <Offer price1={1280} price2={270} price3={12}/>
                        <Offer price1={2560} price2={840} price3={24}/>
                        <Offer price1={5333} price2={2167} price3={50}/>
                    </div>
                </div>

            </div>

        </div>
    );
};